module.exports = __webpack_public_path__ + "img/1.b2993194.jpg";